import React, { useEffect } from 'react';
import { StrengthSalesPage } from './components/StrengthSalesPage';
type PixelFunction = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push?: PixelFunction;
  loaded?: boolean;
  version?: string;
};
export function App() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      const metaWindow = window as Window & {
        fbq?: PixelFunction;
        _fbq?: PixelFunction;
      };
      if (!metaWindow.fbq) {
        const pixel = ((...args: unknown[]) => {
          if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue.push(args);
        }) as PixelFunction;
        pixel.queue = [];
        pixel.push = pixel;
        pixel.loaded = true;
        pixel.version = '2.0';
        metaWindow.fbq = pixel;
        metaWindow._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
      }
      metaWindow.fbq?.('init', '943022892065433');
      metaWindow.fbq?.('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel initialization skipped:', error);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="3reccfffk0fdk">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=943022892065433&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="5yi8qe3h5da" />
      </noscript>
      <StrengthSalesPage data-id="element-2" data-mp="33m5bs42spm8c" />
    </>;
}